import { AuditConfigSection } from "@/components/settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/audit-config")({
  component: AuditConfigSection,
});
